import { createContext, useContext, useState, type ReactNode } from 'react'

type RequestDetailContextValue = {
  showHiddenSteps: boolean
  toggleHiddenSteps: () => void
}

const RequestDetailContext = createContext<RequestDetailContextValue | undefined>(undefined)

export const useRequestDetailContext = () => {
  const context = useContext(RequestDetailContext)
  if (!context) {
    return {
      showHiddenSteps: false,
      toggleHiddenSteps: () => {},
    }
  }
  return context
}

type RequestDetailProviderProps = {
  children: ReactNode
}

export const RequestDetailProvider = ({ children }: RequestDetailProviderProps) => {
  const [showHiddenSteps, setShowHiddenSteps] = useState(false)

  const toggleHiddenSteps = () => {
    setShowHiddenSteps(!showHiddenSteps)
  }

  return <RequestDetailContext.Provider value={{ showHiddenSteps, toggleHiddenSteps }}>{children}</RequestDetailContext.Provider>
}
